import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="drawer-instance"
export default class extends Controller {
  static targets = ["overlay", "body", "form", "table", "content"]
  static values = {
    unsavedChangesPrompt: {type: String, default: "You have unsaved changes, discard?"},
  }

  connect() {
    this.touched = false;
    this.appBody = document.querySelector("html");
  }



  open({ detail: { instance }}) {
    // The drawer controller dispatches to window
    // so we need to check if the instance matches
    // this drawer instance
    if (!this.element.id.match(instance)) {
      return
    }

    if (this.overlayTarget.classList.contains("animate-open")) {
      return
    }

    this.#resetState();

    this.bodyTarget.classList.remove("animate-close")
    this.overlayTarget.classList.remove("animate-close")
    this.bodyTarget.classList.add("animate-open")
    this.overlayTarget.classList.add("animate-open")
    this.appBody.classList.add("overflow-hidden")
  }

  close(event) {
    if (!this.overlayTarget.classList.contains("animate-open")) {
      return
    }

    let closeParam = event.params["close"]

    if (this.touched && closeParam != "force") {
      let exit = confirm(this.unsavedChangesPromptValue)
      if (!exit) {
        return
      } else {
        this.#resetState();
      }
    }

    this.bodyTarget.classList.remove("animate-open")
    this.overlayTarget.classList.remove("animate-open")
    this.bodyTarget.classList.add("animate-close")
    this.overlayTarget.classList.add("animate-close")
    this.appBody.classList.remove("overflow-hidden")
  }

  // Close without the unsaved-changes confirm — used after a successful server
  // save (e.g. the transform drawer closes once the transform persists).
  forceClose() {
    if (!this.overlayTarget.classList.contains("animate-open")) {
      return
    }

    this.#resetState();
    this.bodyTarget.classList.remove("animate-open")
    this.overlayTarget.classList.remove("animate-open")
    this.bodyTarget.classList.add("animate-close")
    this.overlayTarget.classList.add("animate-close")
    this.appBody.classList.remove("overflow-hidden")
  }

  click({detail: { identifier }}) {
    if (!this.element.id.match(identifier)) {
      return
    }

    this.touched = true;
  }

  #resetState() {
    if (this.hasTableTarget) {
    // Just invoke the child controller directly, I don't want to send another event.
    const hiddenRowsController = this.application.getControllerForElementAndIdentifier(this.tableTarget, "schema-drawer-hidden-row");
    if (hiddenRowsController) {
      hiddenRowsController.toggle();
      }
    }

    if (this.hasFormTarget) {
      this.formTarget.reset();
    }

    this.touched = false;
  }
}
